import React from 'react';

import { useAppState } from 'src/Context';

export const usePlacesAndUnits = () => {
  const { people } = useAppState();

  const { places, units } = React.useMemo(() => {
    const placesArr: string[] = [];
    const unitsArr: string[] = [];

    people.forEach((item) => {
      if (item.f?.trim() !== '') {
        placesArr.push(item.f.trim());
      }
    });

    people.forEach((item) => {
      if (item.k?.trim() !== '') {
        unitsArr.push(item.k.trim());
      }
    });

    return {
      places: [...new Set(placesArr.sort())],
      units: [...new Set(unitsArr.sort())],
    };
  }, [people]);

  return { places, units };
};
